import { OpeningHours } from '../hooks/types'

/**
 * Formats a time string from 24-hour format (e.g., "0830") to 12-hour format with am/pm (e.g., "8:30am")
 * Returns "Closed" if the input is "Closed" or invalid
 */
export const formatTime = (time: string): string => {
  if (!time || typeof time !== 'string') {
    return 'Closed'
  }

  const timeLower = time.toLowerCase().trim()
  if (timeLower === 'closed') {
    return 'Closed'
  }

  if (time.length < 4) {
    return 'Closed'
  }

  const hours = Number.parseInt(time.slice(0, 2), 10)
  const minutes = time.slice(2, 4)

  if (
    Number.isNaN(hours) ||
    Number.isNaN(Number.parseInt(minutes, 10)) ||
    hours > 23 ||
    Number.parseInt(minutes, 10) > 59
  ) {
    return 'Closed'
  }

  const period = hours >= 12 ? 'pm' : 'am'
  const displayHours = hours === 0 ? 12 : hours > 12 ? hours - 12 : hours

  return `${displayHours}:${minutes}${period}`
}

/**
 * Formats opening hours for display
 * Returns an array of day objects with formatted times
 */
export const formatOpeningHours = (
  openingHours: OpeningHours,
): Array<{ day: string; hours: string }> => {
  const days = [
    'monday',
    'tuesday',
    'wednesday',
    'thursday',
    'friday',
    'saturday',
    'sunday',
  ] as const

  return days.map((day) => {
    const dayHours = openingHours[day]
    const capitalizedDay = day.charAt(0).toUpperCase() + day.slice(1)

    const startFormatted = formatTime(dayHours.start)
    const endFormatted = formatTime(dayHours.end)

    if (startFormatted === 'Closed' || endFormatted === 'Closed') {
      return {
        day: capitalizedDay,
        hours: 'Closed',
      }
    }

    return {
      day: capitalizedDay,
      hours: `${startFormatted} - ${endFormatted}`,
    }
  })
}
